export default __webpack_public_path__ + "52abfca7bce7f3216b48d144c32b25d6.svg";